"use strict";

exports.__esModule = true;
exports.YEAR_IN_MILLIS = exports.WEEK_IN_MILLIS = exports.SECOND_IN_MILLIS = exports.MINUTE_IN_MILLIS = exports.HOUR_IN_MILLIS = exports.DAY_IN_MILLIS = void 0;
exports.getDaysMillis = getDaysMillis;
exports.getHoursMillis = getHoursMillis;
exports.getMinutesMillis = getMinutesMillis;
exports.getSecondsMillis = getSecondsMillis;
var YEAR_IN_MILLIS = exports.YEAR_IN_MILLIS = 31536000000;
var WEEK_IN_MILLIS = exports.WEEK_IN_MILLIS = 604800000;
var DAY_IN_MILLIS = exports.DAY_IN_MILLIS = 86400000;
var HOUR_IN_MILLIS = exports.HOUR_IN_MILLIS = 3600000;
var MINUTE_IN_MILLIS = exports.MINUTE_IN_MILLIS = 60000;
var SECOND_IN_MILLIS = exports.SECOND_IN_MILLIS = 1000;
function getDaysMillis(numberOfDays) {
  return DAY_IN_MILLIS * numberOfDays;
}
function getHoursMillis(numberOfHours) {
  return HOUR_IN_MILLIS * numberOfHours;
}
function getMinutesMillis(numberOfMinutes) {
  return MINUTE_IN_MILLIS * numberOfMinutes;
}
function getSecondsMillis(numberOfSeconds) {
  return SECOND_IN_MILLIS * numberOfSeconds;
}